export default (to, from, next) => {
  const path = to.fullPath.slice(1, to.fullPath.length).split('/')
  if (path[0] === 'http:' || path[0] === 'https:') window.open(path.join('/'), '_blank')
  else next('/')
}



// WEBPACK FOOTER //
// ./src/router/general/externalPath.js